import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import React, { useEffect, useState } from "react";
import BottomNav from "../../components/bottomNav";
import { useHistory } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useProfileState = createPersistedState("profile");

function SubmitStep({ data, fromRoute }) {
  const { previousStep } = useWizard();
  const history = useHistory();
  const { t } = useTranslation();
  const [token] = useTokenState();
  const [pid] = usePIDState();
  const [profile, setProfile] = useProfileState();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const getUrl = () => `/api/v1/users/profile/${pid}/dietinfo`;

  const transformDataForApi = (state) => {
    console.log(state, "state");
    return [
      {
        type: "RADIO",
        question:
          "What best describes the type of work or daily activity at your job?",
        code: "D1",
        choices: [
          {
            text: "Sedentary",
            code: "D1C1",
            correct: state.D1._state?.code === "D1C1",
          },
          {
            text: "Light activity",
            code: "D1C2",
            correct: state.D1._state?.code === "D1C2",
          },
          {
            text: "Physically Demanding",
            code: "D1C3",
            correct: state.D1._state?.code === "D1C3",
          },
          {
            text: "Unemployed",
            code: "D1C4",
            correct: state.D1._state?.code === "D1C4",
          },
          {
            text: "Retired",
            code: "D1C5",
            correct: state.D1._state?.code === "D1C5",
          },
          {
            text: "Student",
            code: "D1C6",
            correct: state.D1._state?.code === "D1C6",
          },
          {
            text: "Homemaker",
            code: "D1C7",
            correct: state.D1._state?.code === "D1C7",
          },
        ],
        response: state.D1._state?.code || "",
      },
      {
        type: "RADIO",
        question: "Does your job has shift base work?",
        code: "D2",
        choices: [
          {
            text: "Fixed Day Shift",
            code: "D2C1",
            correct: state.D2._state?.code === "D2C1",
          },
          {
            text: "Fixed Night Shift",
            code: "D2C2",
            correct: state.D2._state?.code === "D2C2",
          },
          {
            text: "Varies Rotationally",
            code: "D2C3",
            correct: state.D2._state?.code === "D2C3",
          },
          {
            text: "No fixed hours of working",
            code: "D2C4",
            correct: state.D2._state?.code === "D2C4",
          },
        ],
        response: state.D2._state?.code || "",
      },
      {
        type: "MULTI",
        question: "Do you have any of the following digestive problems?",
        code: "D3",
        choices: [
          {
            text: "Bloating",
            code: "D3C1",
            correct: state.D3._state?.["D3C1"]?.checked || false,
          },
          {
            text: "Gas",
            code: "D3C2",
            correct: state.D3._state?.["D3C2"]?.checked || false,
          },
          {
            text: "Constipation",
            code: "D3C3",
            correct: state.D3._state?.["D3C3"]?.checked || false,
          },
          {
            text: "Acidity",
            code: "D3C4",
            correct: state.D3._state?.["D3C4"]?.checked || false,
          },
          {
            text: "None of these",
            code: "D3C5",
            correct: state.D3._state?.["D3C5"]?.checked || false,
          },
        ],
        response: null,
      },
      {
        type: "TEXT",
        question: "Are you allergic to any food??",
        code: "D4",
        choices: null,
        response: state.D4._state || "",
      },
      {
        type: "MULTI",
        question: "Select if you Consume the following",
        code: "D5",
        choices: [
          {
            text: "Alcohol",
            code: "D5C1",
            correct: state.D5._state?.["D5C1"]?.checked || false,
          },
          {
            text: "Tobacco",
            code: "D5C2",
            correct: state.D5._state?.["D5C2"]?.checked || false,
          },
          {
            text: "Aerated/Cold drinks",
            code: "D5C3",
            correct: state.D5._state?.["D5C3"]?.checked || false,
          },
          {
            text: "None of these",
            code: "D5C4",
            correct: state.D5._state?.["D5C4"]?.checked || false,
          },
        ],
        response: null,
      },
      {
        type: "RADIO",
        question: "How fast do you chew food?",
        code: "D6",
        choices: [
          {
            text: "Slow",
            code: "D6C1",
            correct: state.D6._state?.code === "D6C1",
          },
          {
            text: "Medium",
            code: "D6C2",
            correct: state.D6._state?.code === "D6C2",
          },
          {
            text: "Fast",
            code: "D6C3",
            correct: state.D6._state?.code === "D6C3",
          },
        ],
        response: state.D6._state?.code || null,
      },
      {
        type: "RADIO",
        question: "How much water do you drink every day?",
        code: "D7",
        choices: [
          {
            text: "Less than 6 glasses",
            code: "D7C1",
            correct: state.D7._state?.code === "D7C1",
          },
          {
            text: "6 to 8 glasses",
            code: "D7C2",
            correct: state.D7._state?.code === "D7C2",
          },
          {
            text: "More than 8 glasses",
            code: "D7C3",
            correct: state.D7._state?.code === "D7C3",
          },
        ],
        response: state.D7._state?.code,
      },

      {
        type: "RADIO",
        question: "For women: Please provide menstrual information.",
        code: "D9",
        choices: [
          {
            text: "Regular",
            code: "D9C1",
            correct: state.D9._state?.code === "D9C1",
          },
          {
            text: "Irregular",
            code: "D9C2",
            correct: state.D9._state?.code === "D9C2",
          },
          {
            text: "Not Applicable",
            code: "D9C3",
            correct: state.D9._state?.code === "D9C3",
          },
        ],
        response: state.D9._state?.code || null,
      },
    ];
  };

  const submitDietInfo = async (data) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(getUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(transformDataForApi(data)),
      });

      const responseData = await response.json();

      if (responseData?.status?.success) {
        setSubmitSuccess(true);
        setProfile((profileState) => ({
          ...profileState,
          dietInfoFilled: true,
        }));
        setTimeout(() => {
          if (fromRoute) {
            const url = new URL(fromRoute, window.location.origin);

            url.searchParams.set("dietInfoFilled", "true");
            history.push(url.pathname + url.search);

            return;
          }
          history.push("/my-health");
        }, 2000); // Redirect after 2 seconds
      } else {
        setError(responseData?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Submission error:", err);
      setError("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    submitDietInfo(data);
  }, []);

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("title")}
        hideLibrary={true}
      />
      <div className="body_content">
        <div className="inner_body">
          <div className="successful_msg mt-5 pt-5 h-100 align-items-center">
            {isSubmitting ? (
              <h3 className="subtitle mb-4 text-center">{"Submitting..."}</h3>
            ) : error ? (
              <>
                <h3 className="subtitle mb-4 text-center text-danger">
                  {error}
                </h3>
                <button
                  className="btn btn_primary"
                  onClick={() => submitDietInfo(data)}
                >
                  {"Retry"}
                </button>
              </>
            ) : submitSuccess ? (
              <>
                <h3 className="subtitle mb-4 text-center">{"Success"}</h3>
                <p className="text-center">{"Redirecting..."}</p>
              </>
            ) : (
              <h3 className="subtitle mb-4 text-center">{"Submitting..."}</h3>
            )}
          </div>
          {/* <BottomNav /> */}
        </div>
      </div>
    </>
  );
}

export default SubmitStep;
